import { BLOCK_TYPE } from '../../common/types/BlockType';

export const RULE_BLOCK_TYPES: { value: BLOCK_TYPE; label: string }[] = [
    { value: 'LINE_BLOCK', label: 'LINE' },
    { value: 'TEXTBOX_BLOCK', label: 'TEXTBOX' },
    { value: 'TABLE_BLOCK', label: 'TABLE' },
    { value: 'CELL_BLOCK', label: 'CELL' },
    { value: 'HORIZONTAL_LINE_BLOCK', label: 'HORIZONTAL' },
    { value: 'CLUSTER_BLOCK', label: 'CLUSTER' },
    { value: 'HORIZONTAL_MULTILINE_BLOCK', label: 'HORIZONTAL_MULTILINE' },
    { value: 'PARAGRAPH_BLOCK', label: 'PARAGRAPH' },
    { value: 'PAGE_BLOCK', label: 'PAGE' },
    { value: 'WORD_BLOCK', label: 'WORD' },
    { value: 'DOCUMENT_TABLE_BLOCK', label: 'DOCUMENT_TABLE' },
    { value: 'FORM_ITEM_BLOCK', label: 'FORM_ITEM' },
    { value: 'SMART_BLOCK', label: 'SMART' },
    { value: 'INTERPRETATION_BLOCK', label: 'INTERPRETATION' },
    { value: 'DOCUMENT_BLOCK', label: 'DOCUMENT' }
];

export function getIncludedBlockTypes(included: string[] | null | undefined, excluded: string[] = []): string[] {
    return Array.isArray(included)
        ? included
        : RULE_BLOCK_TYPES.map(type => type.value).filter(type => !excluded.includes(type));
}
